import styles from "./ConsentPopUp.module.css";
import { Button } from "../components/Button/Button";

import { useHistory } from "react-router-dom";
import { NavigationSvc } from "../navigationScv";
import logo from "./Hands.svg";
import help from "./Help.png";
import shareButton from "./Share.svg";

import mobile from "mobileBridge";
import environment from "environment";

import { useAccount } from "utils/AccountInfoContext";
import { useTranslation, Trans } from "react-i18next";

export function ConsentPopUp() {
  const { t } = useTranslation();
  const history = useHistory();
  const {
    setDirectToConsentNagScreen,
    issuesData,
    nagScreenData,
    privacyData,
  } = useAccount();
  const navigationSvc = new NavigationSvc();

  const goBackToReferrerIfExists = async () => {
    let _prevUrl = document.referrer;

    if (
      _prevUrl &&
      !_prevUrl.includes("settings") &&
      !_prevUrl.includes("apps-dev.wwdb.com") &&
      !_prevUrl.includes("apps-staging.wwdb.com") &&
      !_prevUrl.includes("wwdb.com")
    ) {
      window.location.assign(_prevUrl);
    } else {
      history.push("/");
    }
  };

  const handleGoBack = async () => {
    if (
      (privacyData && privacyData.agreedLatest === false) ||
      (nagScreenData && nagScreenData.length > 0) ||
      (issuesData && issuesData.length)
    ) {
      await goBackToReferrerIfExists();
    } else {
      // console.log("backed");
      history.goBack(2);
    }
  };

  const onDismiss = async () => {
    setDirectToConsentNagScreen(false);
    handleGoBack();
  };

  return (
    <>
      <div className={styles.container}>
        <div className={styles.buttonRow}>
          {/* <Button
            onClick={onDismiss}
            buttonText={"Skip"}
            className={styles.btnColor}
          ></Button> */}
        </div>

        <div className={styles.row}>
          <img src={logo} />
          <div className={styles.title}>{t("Amway + WWG Sharing")}</div>
        </div>
        <div className={styles.row}>
          <div className={styles.info}>
            <Trans i18nKey="Giving Approved Provider (AP) Consent">
              Giving <strong>Approved Provider (AP) Consent</strong> to Amway™
              is a requirement of Premier Membership
            </Trans>
          </div>
        </div>
        <div className={styles.row}>
          <div className={styles.info}>
            {t("In an effort to make user experience seamless")}
          </div>
        </div>
        <div className={styles.row}>
          <div className={styles.info}>{t("To provide your consent")}</div>
        </div>
        <div className={styles.row}>
          <img
            src={shareButton}
            onClick={() => {
              mobile.isApp()
                ? mobile.openLink(
                    "https://account.amway.com/my-account/approved-provider/WWG"
                  )
                : window
                    .open(
                      "https://account.amway.com/my-account/approved-provider/WWG"
                    )
                    ?.focus();
            }}
          />
        </div>
        <div className={styles.divider} />
        <div className={styles.row}>
          <div className={styles.header}>{t("Questions")}</div>
          <img
            className={styles.imageLink}
            src={help}
            onClick={() => {
              if (mobile.isApp()) {
                navigationSvc.goToApp("help", {});
              } else {
                window.location.href = environment.helpUrl;
              }
            }}
          />
          <div className={styles.info}>
            <i>{t("We're here when you need us")}</i>
          </div>
        </div>
      </div>
    </>
  );
}

ConsentPopUp.propTypes = {};
